import { ReactComponent as Youtube } from 'assets/icons/logo-youtube.svg';

const YoutubeIcon = () => {
  return <Youtube style={{ height: 30, width: 30 }} />;
};

export default YoutubeIcon;
